function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 16,
  rx: 2,
  fill: "#E8A782"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7552 6.78002L15.7552 8.73822C16.4686 8.91785 17.0003 9.56462 17 10.3392C17 11.2574 16.2627 12 15.3549 12C14.4471 12 13.7098 11.2574 13.7098 10.3392C13.7098 9.56462 14.2451 8.91784 14.9626 8.73822L14.9626 6.78002C14.9626 6.64822 14.8556 6.54047 14.7247 6.54047H10.3965V8.73822C11.114 8.918 11.6451 9.56463 11.6451 10.3392C11.6451 11.2574 10.9078 12 10 12C9.09225 12 8.35495 11.2574 8.35495 10.3392C8.35495 9.56463 8.89014 8.91785 9.60373 8.73822V6.54047L5.27925 6.54047C5.14838 6.54047 5.04139 6.64821 5.04139 6.78002L5.04139 8.73822C5.75892 8.918 6.29017 9.56462 6.29017 10.3392C6.29017 11.2574 5.55287 12 4.64509 12C3.7373 12 3 11.2574 3 10.3392C3 9.56462 3.53504 8.91784 4.24863 8.73822V6.78002C4.24863 6.20908 4.71251 5.74195 5.27937 5.74195L9.60348 5.74195V3.40038C9.60348 3.18302 9.77852 3.00621 9.99587 3.00403C10.2163 3.00181 10.3962 3.17991 10.3962 3.40038V5.74195H14.7245C15.2914 5.74195 15.7552 6.20912 15.7552 6.78002Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 0.8
});

function SvgLineSharing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineSharing);
export default __webpack_public_path__ + "static/media/line_sharing.57db956e.svg";
export { ForwardRef as ReactComponent };